import '../styles/pages/aventura.css'

export const AventuraTotalPage = () => {
  const imgSrc = '../assets/aventuraTotal/'
  const fuenteAntigua = 'AT-Antigua-'
  const fuenteGuate = 'AT-Guate-'
  const fuenteLago = 'AT-Lago-'
  const fuenteFlores = 'AT-Flores-'
  const imgName = ['Antigua.jpg', 'Lago.jpg', 'Pacaya.jpg', 'Tikal.jpg', 'Acatenango.jpg', 'ChichiPana.jpg',]
  const imgTours = ['Antigua.jpg', 'Lago.jpg', 'Pacaya.jpg', 'Tikal.jpg', 'Acatenango.jpg', 'HobbitenangoAltamira.jpg', 'AntiguaCity.jpg', 'AntiguaHobbitenango.jpg', 'AntiguaLago.jpg', 'AntiguaPacaya.jpg', 'AntiguaCity.jpg', ]
  return (
    <div className='aventura-total-main-container'>
      <h3>Tours desde Antigua Guatemala</h3>
        <div className="aventura-total-tours-desde-antigua">
          {
            imgName.map((name, index) => (
              <img key={index} className="at-tours-antigua" src={ imgSrc + fuenteAntigua + name } alt={`Aventura-Total-Antigua-${name.split('.')[0]}`} />
            ))
          }
        </div>
      <h3>Tours desde Ciudad de Guatemala</h3>
        <div className="aventura-total-tours-desde-guate">
          {
            imgTours.map((name, index) => (
              <img key={index} className="at-tours-guate" src={ imgSrc + fuenteGuate + name } alt={`Aventura-Total-Guate-${name.split('.')[0]}`} />
            ))
          }
        </div>

      {/* <h3>Tours desde Lago de Atitlán</h3>
        <div className="aventura-total-tours-desde-lago">
          {
            imgName.map((name, index) => (
              <img key={index} className="at-tours-lago" src={ imgSrc + fuenteLago + name } alt={`Aventura-Total-Lago-${name.split('.')[0]}`} />
            ))
          }
        </div>

      <h3>Tours desde Isla de Flores</h3>
        <div className="aventura-total-tours-desde-flores">
          {
            imgName.map((name, index) => (
              <img key={index} className="at-tours-flores" src={ imgSrc + fuenteFlores + name } alt={`Aventura-Total-Flores-${name.split('.')[0]}`} />
            ))
          }
        </div> */}

      {/* <h3>Giras de Turismo</h3> */}
      
      <div className="aventura-total-faqs">
        <img src={imgSrc + 'AT-FAQs.jpg'} alt="Frequently Asked Questions" className="at-faqs" />
      </div>

      {/* <h3>Contacto</h3> */}
    </div>
  )
}
